(function () {
  "use strict";

  var lastFireTs = 0;
  var drawerWasOpen = false;
  var WRAPPER_SELECTOR = ".popup-custom-addtocart-new";
  var INNER_SELECTOR = ".popup-custom-addtocart";
  var CART_BUTTON_SELECTOR = ".site-header-cart--button";
  var openedByCartIcon = false;

  function isCartPage() {
    if (document.body && document.body.classList.contains("template-cart")) {
      return true;
    }
    var path = window.location.pathname.replace(/\/+$/, "");
    return /\/cart$/.test(path);
  }

  function isViewCartSuppressed() {
    return Date.now() < (window.__ga4SuppressViewCartUntil || 0);
  }

  function isDrawerOpen() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (wrapper && window.getComputedStyle(wrapper).display !== "none") {
      return true;
    }

    var inner = document.querySelector(INNER_SELECTOR);
    if (!inner) return false;

    var style = window.getComputedStyle(inner);
    if (style.display === "none" || style.visibility === "hidden") return false;

    var rect = inner.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function cleanVariantTitle(title) {
    if (!title || title === "Default Title") return "";
    return title;
  }

  function parseMoney(text) {
    if (!text) return 0;
    var normalized = String(text).replace(/[^0-9.,]/g, "");
    if (!normalized) return 0;
    if (normalized.indexOf(",") > -1 && normalized.indexOf(".") > -1) {
      normalized = normalized.replace(/,/g, "");
    } else if (normalized.indexOf(",") > -1) {
      normalized = normalized.replace(",", ".");
    }
    var value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
  }

  function resolveCoupon(cart) {
    if (
      cart &&
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length
    ) {
      return cart.cart_level_discount_applications[0].title || "";
    }
    if (cart && cart.discount_codes && cart.discount_codes.length) {
      var applied = cart.discount_codes.filter(function (code) {
        return code.applicable !== false;
      });
      if (applied.length) return applied[0].code || "";
    }
    return "";
  }

  function readDiscountFromCartDom(variantId) {
    if (!variantId) return 0;
    var row = document.querySelector('[data-cartitem-id="' + variantId + '"]');
    if (!row) return 0;

    var attrDiscount = parseFloat(row.getAttribute("data-ga-discount") || "");
    if (!isNaN(attrDiscount) && attrDiscount > 0) return attrDiscount;

    var compareAttr = parseFloat(row.getAttribute("data-ga-compare-at") || "");
    var priceAttr = parseFloat(row.getAttribute("data-ga-price") || "");
    if (!isNaN(compareAttr) && !isNaN(priceAttr) && compareAttr > priceAttr) {
      return Number((compareAttr - priceAttr).toFixed(2));
    }

    var compareEl =
      row.querySelector(".cart-item--content-price s.cart-item--sale-price") ||
      row.querySelector(".cart-item--content-price s.money") ||
      row.querySelector("s.original-price") ||
      row.querySelector("s.money");
    var priceEl =
      row.querySelector(".cart-item--content-price span.money.cart-item--discount-price") ||
      row.querySelector(".cart-item--content-price span.money") ||
      row.querySelector(".cart-item--content-price .money:not(s)");

    var compare = parseMoney(compareEl ? compareEl.textContent : "");
    var price = parseMoney(priceEl ? priceEl.textContent : "");
    if (compare > price && price > 0) {
      return Number((compare - price).toFixed(2));
    }
    return 0;
  }

  function calcVariantDiscount(variant) {
    if (!variant) return 0;
    var compareAt = Number(variant.compare_at_price) || 0;
    var price = Number(variant.price) || 0;
    if (compareAt > price) return Number(((compareAt - price) / 100).toFixed(2));
    return 0;
  }

  function extractHandle(item) {
    if (!item) return "";
    if (item.handle) return item.handle;
    var url = item.url || "";
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  var productCache = {};
  var variantCache = {};

  function fetchVariantDiscount(variantId, handle) {
    if (!variantId) return Promise.resolve(0);
    if (variantCache[variantId] != null) return Promise.resolve(variantCache[variantId]);

    var variantUrl = "/variants/" + encodeURIComponent(variantId) + ".js";
    return fetch(variantUrl, { credentials: "same-origin" })
      .then(function (res) {
        if (res && res.ok) return res.json();
        return null;
      })
      .then(function (variant) {
        var discount = 0;
        if (variant) {
          discount = calcVariantDiscount(variant);
          variantCache[variantId] = discount;
          return discount;
        }

        if (!handle) return 0;
        if (productCache[handle]) {
          var cached = productCache[handle];
          var v = (cached.variants || []).find(function (x) {
            return String(x.id) === String(variantId);
          });
          discount = calcVariantDiscount(v);
          variantCache[variantId] = discount;
          return discount;
        }

        return fetch("/products/" + encodeURIComponent(handle) + ".js", {
          credentials: "same-origin"
        })
          .then(function (res) {
            if (!res || !res.ok) return null;
            return res.json();
          })
          .then(function (product) {
            if (!product) return 0;
            productCache[handle] = product;
            var match = (product.variants || []).find(function (x) {
              return String(x.id) === String(variantId);
            });
            discount = calcVariantDiscount(match);
            variantCache[variantId] = discount;
            return discount;
          });
      })
      .catch(function () {
        return 0;
      });
  }

  function buildBaseItem(item, idx) {
    var unitFinal = (item.final_price != null ? item.final_price : item.price) / 100;
    var unitOriginal = (item.original_price != null ? item.original_price : item.price) / 100;
    var discount = unitOriginal > unitFinal ? Number((unitOriginal - unitFinal).toFixed(2)) : 0;
    var variantId = item.variant_id || item.id;

    if (!discount) {
      discount = readDiscountFromCartDom(variantId);
    }

    return {
      item_id: String(item.sku || variantId || ""),
      item_name: item.product_title || item.title || "Product",
      item_brand: item.vendor || "",
      item_category: item.product_type || "",
      item_variant: cleanVariantTitle(item.variant_title),
      price: Number(unitFinal.toFixed(2)),
      discount: discount,
      currency: "AED",
      quantity: item.quantity || 1,
      index: idx + 1,
      _handle: extractHandle(item),
      _variantId: String(variantId || "")
    };
  }

  function enrichItemDiscount(item) {
    if (item.discount > 0) return Promise.resolve(item);

    return fetchVariantDiscount(item._variantId, item._handle).then(function (discount) {
      if (discount > 0) item.discount = discount;
      return item;
    });
  }

  function buildItems(cart) {
    if (!cart || !cart.items) return Promise.resolve([]);

    var baseItems = cart.items.map(function (item, idx) {
      return buildBaseItem(item, idx);
    });

    return Promise.all(baseItems.map(enrichItemDiscount)).then(function (items) {
      return items.map(function (item) {
        delete item._handle;
        delete item._variantId;
        return item;
      });
    });
  }

  function fireViewCart() {
    if (isViewCartSuppressed()) return;

    var now = Date.now();
    if (now - lastFireTs < 2000) return;
    lastFireTs = now;

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        if (!res || !res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return null;
        if (isViewCartSuppressed()) return null;
        return buildItems(cart).then(function (items) {
          if (isViewCartSuppressed()) return;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "view_cart",
            ecommerce: {
              currency: "AED",
              value: Number(((cart.total_price || 0) / 100).toFixed(2)),
              coupon: resolveCoupon(cart),
              items: items
            }
          });
        });
      })
      .catch(function () {});
  }

  function onDrawerOpened() {
    if (!isDrawerOpen()) return;
    if (!openedByCartIcon) return;
    openedByCartIcon = false;
    // Allow cart drawer HTML to settle, then fire (so data-ga-discount attrs are readable)
    window.setTimeout(fireViewCart, 250);
  }

  function scheduleDrawerCheck(attempts) {
    if (isDrawerOpen()) {
      onDrawerOpened();
      return;
    }
    if (attempts > 0) {
      window.setTimeout(function () {
        scheduleDrawerCheck(attempts - 1);
      }, 100);
    }
  }

  function onCartButtonClick() {
    openedByCartIcon = true;
    scheduleDrawerCheck(15);
  }

  function watchCartDrawer() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    drawerWasOpen = isDrawerOpen();

    var observer = new MutationObserver(function () {
      var open = isDrawerOpen();
      if (open && !drawerWasOpen && openedByCartIcon) {
        onDrawerOpened();
      }
      if (!open) openedByCartIcon = false;
      drawerWasOpen = open;
    });

    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }

  function getJQuery() {
    return window.jQuery || window.$;
  }

  function initJQueryHooks() {
    var $ = getJQuery();
    if (!$) return false;
    $(document).on("click", CART_BUTTON_SELECTOR, onCartButtonClick);
    return true;
  }

  function waitForJQuery() {
    if (!initJQueryHooks()) {
      window.setTimeout(waitForJQuery, 200);
    }
  }

  function init() {
    if (isCartPage()) {
      fireViewCart();
    }

    watchCartDrawer();

    document.addEventListener(
      "click",
      function (event) {
        var target =
          event.target && event.target.closest
            ? event.target.closest(CART_BUTTON_SELECTOR)
            : null;
        if (target) onCartButtonClick();
      },
      true
    );

    if (!initJQueryHooks()) {
      waitForJQuery();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
